module.exports = __webpack_public_path__ + "img/cuff_length.ffa684f5.png";